import React from 'react';


function CountDown({ seconds = 0, onEnd }) {
  const [time, setTime] = React.useState({
    minutes: parseInt(seconds / 60),
    seconds: parseInt(seconds % 60),
  });

  const tick = (timerID) => {
    if (time.minutes == 0 && time.seconds == 0) {
      onEnd();
      clearInterval(timerID)
      return;
    } else if (time.seconds == 0)
      setTime({
        minutes: time.minutes - 1,
        seconds: 59,
      });
    else
      setTime({
        minutes: time.minutes,
        seconds: time.seconds - 1,
      });
  };

  React.useEffect(() => {
    let timerID = setInterval(() => tick(timerID), 1000);
    return () => clearInterval(timerID);
  });

  return (
    <div>
      <p className='count'>{`${time.minutes
        .toString()
        .padStart(2, '0')}:${time.seconds.toString().padStart(2, '0')}`}</p>
    </div>
  );
}

export default CountDown;
